document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const openMenu = document.querySelector('[data-menu-open]');
const closeMenu = document.querySelector('[data-menu-close]');
const mobileMenu = document.querySelector('[data-mobile-menu]');

function setMenu(open) {
  if (!mobileMenu || !openMenu) return;
  mobileMenu.hidden = !open;
  openMenu.setAttribute('aria-expanded', String(open));
  document.body.classList.toggle('menu-open', open);
  if (open) closeMenu?.focus(); else openMenu.focus();
}

openMenu?.addEventListener('click', () => setMenu(true));
closeMenu?.addEventListener('click', () => setMenu(false));
mobileMenu?.addEventListener('click', (event) => {
  if (event.target === mobileMenu || event.target.closest('a')) setMenu(false);
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && mobileMenu && !mobileMenu.hidden) setMenu(false);
});

document.querySelectorAll('[data-archive-section]').forEach((section) => {
  const tabs = [...section.querySelectorAll('[data-archive-tab]')];
  const panels = [...section.querySelectorAll('[data-archive-panel]')];
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
      panels.forEach((panel) => { panel.hidden = panel.dataset.archivePanel !== tab.dataset.archiveTab; });
    });
  });
});

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const variantSelect = section.querySelector('[data-variant-select]');
  const variantInput = section.querySelector('[data-variant-id]');
  const price = section.querySelector('[data-product-price]');
  const addButton = section.querySelector('[data-add-button]');
  const addButtonText = section.querySelector('[data-add-button-text]');
  const variantsNode = section.querySelector('[data-product-json]');
  let variants = [];
  try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) {}

  variantSelect?.addEventListener('change', () => {
    const variant = variants.find((item) => String(item.id) === variantSelect.value);
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    if (price) {
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
      price.innerHTML = `<span>${formatter.format(variant.price / 100)}</span>${variant.compare_at_price > variant.price ? `<s>${formatter.format(variant.compare_at_price / 100)}</s>` : ''}`;
    }
    if (addButton) addButton.disabled = !variant.available;
    if (addButtonText) addButtonText.textContent = variant.available ? 'Add to bag' : 'Sold out';
  });

  const quantity = section.querySelector('[data-quantity-input]');
  section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
  section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });

  const mainImage = section.querySelector('[data-product-main-image]');
  section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.imageSrc;
      mainImage.srcset = '';
      mainImage.alt = thumb.dataset.imageAlt || '';
    });
  });
});

document.querySelectorAll('[data-sort-select]').forEach((select) => {
  select.addEventListener('change', () => select.form?.submit());
});

document.addEventListener('shopify:section:load', () => window.location.reload());
